import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { faEllipsisV } from '@fortawesome/pro-solid-svg-icons';

import ActivityBody from './body';
import ActionsMenu from 'components/actions_menu';
import ClickableIcon from 'components/clickable_icon';
import confirm from 'components/confirm';
import Modal from '../modal';
import Parent from './parent';
import Icon from './icon';
import { activityTypes } from 'bundles/apex/activities/type/config';
import { formatDate } from 'helpers/formatters/date_time_formats';
import { deleteActivity } from 'bundles/apex/activities/form/helpers';

import './styles.scss';

export default function Activity({
  activity,
  isBackofficeAdmin,
  currentParent,
  forUserId,
  options,
  showParent,
  tagText,
  onDelete,
  onSave,
}) {
  const [showEditModal, setShowEditModal] = useState(false);
  let canEdit = !activity.hasCrmEmail;
  let canDelete = true;

  if (forUserId != null) {
    const isCreator = forUserId === activity.creator.id;
    canEdit = isCreator && !activity.hasCrmEmail;
    canDelete = isCreator || isBackofficeAdmin;
  }

  const handleDelete = (event) => {
    event.stopPropagation();

    confirm('Are you sure you want to delete this activity?', {
      buttonLabel: 'Delete',
      buttonStyle: 'danger',
      title: `Delete Activity?`
    }).then(async () => {
      const deletedActivity = await deleteActivity(activity);
      onDelete(deletedActivity);
    });
  };

  return (
    <div className="deal-activity my-4">
      <div className="d-flex">
        <Icon activity={activity} />

        <div className="flex-1 ml-4">
          <div className="d-flex">
            <div className="flex-1">
              <div>
                {activity.creator.name} {activityTypes[activity.activityType].phrase}
              </div>

              <div className="text-muted text-xs my-2">
                {showParent &&
                  <Parent
                    activity={activity}
                    asLink={showParent === 'path'}
                    currentParent={currentParent}
                    options={options}
                  />
                }
                {formatDate(activity.date)}
              </div>

            </div>

            <ActionsMenu
              disableDelete={!canDelete}
              disableEdit={!canEdit}
              icon={<ClickableIcon icon={faEllipsisV} />}
              id={activity.id}
              onDelete={handleDelete}
              onShowModal={() => setShowEditModal(true)}
            />
          </div>

          <ActivityBody activity={activity} />
        </div>

        <Modal
          activity={activity}
          header="Edit activity"
          options={options}
          show={showEditModal}
          tagText={tagText}
          onHide={() => setShowEditModal(false)}
          onSave={onSave}
        />
      </div>
    </div>
  );
}

Activity.propTypes = {
  activity: PropTypes.shape({
    activityType: PropTypes.oneOf(Object.keys(activityTypes)).isRequired,
    creator: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
    date: PropTypes.string.isRequired,
    hasCrmEmail: PropTypes.bool,
  }).isRequired,
  currentParent: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  forUserId: PropTypes.number,
  isBackofficeAdmin: PropTypes.bool,
  options: PropTypes.object,
  showParent: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  tagText: PropTypes.string,
  onDelete: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};
